import { ROUTES } from 'constants/routes';

export const SESSION = {
  TOKEN_COOKIE_KEY: 'persistence-key',
  USER_ID: 'userId',
  USER_NAME: 'userName',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'emailAddress',
  EXP_MINUTES: 30,
  LOGIN_REDIRECT: ROUTES.dashboard,
};


